import { Spinner } from '../../../../../commonComponents/Spinner';
import { Colors } from '../../../../../../themes/colors';
import { NewCustomPopup } from '../../../../../commonComponents/NewCustomPopup';
import history from '../../../../../../history';
import { useGetOnsiteInterviewList } from '../../../../../../domain/PermanentJobs/useCases/useGetOnsiteInterviewList';
import {
  JobStatus,
  JobStatusMapper,
  OfferCounterStatus,
} from '../../../../../../domain/PermanentJobs/enums';

export const OnsiteInterviewsPopup = ({ postingId, professionalId, onClose }) => {
  const { data: interviews, isLoading } = useGetOnsiteInterviewList({ postingId, professionalId });

  const isNotAccepted = (it) =>
    it.jobStatus === JobStatus.EXPIRED || it.offerCounterStatus === OfferCounterStatus.DECLINED;

  const handleRowClick = (jobId) => {
    history.push(`/job/${jobId}?scrollToTab=true`);
  };

  return (
    <NewCustomPopup
      title="Onsite Interviews"
      rightButtonText="Close"
      rightButtonPressed={onClose}
      rightButtonProps={{
        style: {
          backgroundColor: Colors.primary_500,
          width: 152,
          height: 48,
          borderRadius: 25,
        },
      }}
      onCloseIconClick={onClose}
      containerStyle={{ paddingTop: 20 }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          width: '100%',
          paddingInline: 20,
          marginBottom: 20,
          marginTop: 20,
          maxHeight: 350,
          overflowY: 'auto',
        }}
      >
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 200,
            }}
          >
            <Spinner />
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {interviews.map((interview) => (
              <div
                key={interview.id}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 8,
                  padding: '14px 8px',
                  borderBottom: `1.5px solid ${Colors.neutral_100}`,
                  cursor: 'pointer',
                }}
                onClick={() => handleRowClick(interview.id)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = Colors.neutral_100;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flex: 1,
                    justifyContent: 'space-between',
                  }}
                >
                  <div className="bold f-dark" style={{ fontSize: 13 }}>
                    {interview.localDate}
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flex: 1,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 4,
                  }}
                >
                  <span
                    className="bold f-dark"
                    style={{ fontSize: 13, textTransform: 'lowercase' }}
                  >
                    {interview.localStartTime} - {interview.localEndTime}
                  </span>
                  {!isNotAccepted(interview) ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span
                        className="bold f-dark"
                        style={{ fontSize: 13, textTransform: 'capitalize' }}
                      >
                        {interview.jobStatus}
                      </span>
                      <span
                        style={{
                          width: 16,
                          height: 16,
                          borderRadius: 4,
                          backgroundColor: JobStatusMapper.getInterviewColor(interview.jobStatus),
                        }}
                      />
                    </div>
                  ) : (
                    <span
                      className="bold f-dark"
                      style={{ fontSize: 13, color: '#D0021B', textTransform: 'capitalize' }}
                    >
                      Not Accepted
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </NewCustomPopup>
  );
};
